// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"223":"e83ff96a415ad75e3fb1","532":"babb4793e900a5da9699","691":"4c901d1e0f1a3d000861","843":"74c1c5d490c39f90ec23","954":"a3e3bde05749f32a3ec0"}[chunkId] + ".js";
};